import Card from "./Company_Card";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchCompany } from "../../../store/actions";
import { CircularProgress } from "@mui/material";
import { fetchCompaniesUrl } from "../../../Library/URLs";
import { v4 as uuid } from "uuid";
import axios from "axios";

const CompanyCardsSection = () => {
  const dispatch = useDispatch();
  const User = useSelector((state) => state.payroll?.User);
  //  const user_id = useSelector((state)=>state.admin.transaction_id)
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState("");
  const unique_id = uuid();

  const FetchAllCompanies = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
    };
    setIsLoading(true);
    await axios
      .post(fetchCompaniesUrl, data)
      .then((res) => {
        setIsLoading(false);
        if (res.data) {
          setCompanies(res.data?.data?.filter(company => company?.status==="Active")?.reverse());
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
        setIsLoading(false);
      });
  };

  useEffect(() => {
    FetchAllCompanies();
    // eslint-disable-next-line
  }, []);

  let filteredCompanies = companies?.filter(company => company?.name?.toLowerCase()?.includes(query?.toLowerCase())) ?? [];

  return (
    <div className="Company_Wrapper">
      <h2>Companies</h2>
      <div className="Top_Box">
        <h4>Companies registered on i4smart</h4>
        <Link className="Button" to="/createcompany">
          Create Company
        </Link>
      </div>
      {
          companies?.length > 0 && !isLoading && (
            <div className="mt-4 mb-5" >
              <input 
                type="text"
                onChange={(e)=>setQuery(e.target.value)}
                value={query}
                className="search-input"
                placeholder="Search by Company Name"
              />
            </div>
          )
        }
      <div className="CompanyCards">
        {isLoading && (
          <h3
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            loading.. <CircularProgress size={20} />
          </h3>
        )}
        {(companies?.length === 0 && !isLoading) && (
          <h3
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
            }}
          >
            No recorded company.
          </h3>
        )}
        
        {filteredCompanies?.length > 0 &&
          filteredCompanies?.map((card, index) => (
            <Card text={card.email} id={card.id} title={card.name} key={index} />
          ))}
      </div>
    </div>
  );
};

export default CompanyCardsSection;
